var _style, _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo39(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E21216;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.7,71c50.3,1.4,111.3,3.6,148,41.8c21.3,22.7,33.3,59.5,33.3,92.1c0,43.9-20,68.7-31.2,79.4 c-14.2,14.1-32.6,23.3-50.3,31.8c20.5,6.5,41.8,12.8,60.8,31.2c20.6,20.5,34.7,55.9,34.7,93.5c0.8,32.8-11.7,64.4-34.7,87.8 c-39.6,40.3-92.1,41.1-148.7,42.5h-230V469l44.6,0.7V172.3l-44.6,0.7V71H570.7z M527.5,272.1c40.4,0.8,46,0.8,56-1.4 c23.3-4.9,39.6-26,38.4-49.8c0-26.2-15-41-25.5-46c-10.4-5-18.5-5.7-68.8-6.4L527.5,272.1z M527.5,469h39c27.6,0,66.5-0.6,66.5-48.1 c0-25-13.5-41.8-30.5-48.2c-12-5-17.6-5-75-5L527.5,469z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "-122.5,71 92.1,71 92.1,173 48.2,172.3 121.1,458.4 199.8,172.3 155.9,173 155.9,71 352.7,71 352.7,173  319.4,172.3 195.5,571 34,571 -91.3,172.3 -122.5,173 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo39);
export default __webpack_public_path__ + "static/media/logo39.ca84b9a19a5fcc66af4e3d6b456969a4.svg";
export { ForwardRef as ReactComponent };